import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  EventWithRelationsDto,
  ResponseDto,
  CancelEventDto,
} from "@mimber/schema"
import { eventsKeys } from "../events.utils"
import type { UseCancelEventOptions } from "./useCancelEvent.types"

export const useCancelEvent = (
  eventUuid: string,
  options: UseCancelEventOptions = {}
): UseMutationResult<
  ResponseDto<EventWithRelationsDto>,
  Error,
  CancelEventDto
> => {
  guardAppUsage("mimber-organization", "useCancelEvent")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data: CancelEventDto) => {
      const response = await server.post<ResponseDto<EventWithRelationsDto>>(
        `events/${eventUuid}/cancel`,
        data
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findAll(),
      })
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findOne(eventUuid),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
